import React from 'react';
import CheckButton from '../../components/CheckButton';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckAngry: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 14) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (0 <= total && total < 22) {
                    resultCode = "001";
                } else if (21 < total && total < 36) {
                    resultCode = "002";
                } else if (total > 35) {
                    resultCode = "003";
                }
                window.location.href=`/psychlgclCheck/angry/result/${resultCode}/${total}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='불안 자가진단'
                        />
                        <div className="mobileface testing">
					        <div className="testWrap angry">
                                <h3 className="f18 black">화병 성격척도</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30"><strong className="f16">아래의 각 문항을 읽고 자신에게 해당되는 정보를 체크해 주십시오. </strong></p>
                                </div>
                                <h4 className="f14 green mt30">화병 성격척도 진행 (15문항)</h4>
                                <fieldset>
                                    <ul className="etc_list">
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">1. 내 삶은 불행한 편이다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq1" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq1" value="1" onChange={handleRadioChnage}/> 그렇지 않은 편이다</label>
                                                    <label><input type="radio" name="aq1" value="2" onChange={handleRadioChnage}/> 중간 정도 그렇다</label>
                                                    <label><input type="radio" name="aq1" value="3" onChange={handleRadioChnage}/> 상당히 그렇다</label>
                                                    <label><input type="radio" name="aq1" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">2. 한스러워지는 때가 있다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq2" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq2" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq2" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq2" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq2" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">3. 내 인생이 서글프다고 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq3" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq3" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq3" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq3" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq3" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">4. 나는 서러움을 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq4" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq4" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq4" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq4" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq4" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">5. 나는 억울하게 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq5" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq5" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq5" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq5" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq5" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">6. 나는 신경이 아주 약해져서, 마음을 가눌 수 없다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq6" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq6" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq6" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq6" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq6" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">7. 나는 손발이 떨리고 안절부절 못한다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq7" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq7" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq7" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq7" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq7" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">8. 나는 내 자신에 실망할 때가 많다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq8" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq8" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq8" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq8" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq8" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">9. 얼굴에 열이 자주 달아오른다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq9" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq9" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq9" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq9" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq9" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">10. 가슴 속에 열이 차 있는 것을 자주 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq10" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq10" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq10" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq10" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq10" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">11. 무언가가 아래(다리 또는 배)에서 위(가슴)로 치미는 것을 자주 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq11" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq11" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq11" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq11" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq11" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">12. 화가 나면 손이 저리거나 떨린다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq12" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq12" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq12" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq12" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq12" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">13. 소화가 잘 안되고 체하는 편이다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq13" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq13" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq13" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq13" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq13" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">14. 몹시 피곤하다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq14" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq14" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq14" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq14" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq14" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">15. 세상이 불공평하다고 느낀다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="aq15" value="0" onChange={handleRadioChnage}/> 전혀 그렇지 않다</label>
                                                    <label><input type="radio" name="aq15" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                    <label><input type="radio" name="aq15" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                    <label><input type="radio" name="aq15" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    <label><input type="radio" name="aq15" value="4" onChange={handleRadioChnage}/> 완전히 그렇다</label>
                                                </dd>
                                            </dl>
                                        </li>
                                    </ul>
                                </fieldset>
                                <CheckButton goResult={goResult} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckAngry;